import { ADMIN_STATE_KEY } from "~/admin";
import { IMPORT_FILTER_DATA_KEY } from "./reducer";

const _getModuleState = (state) => state[ADMIN_STATE_KEY][IMPORT_FILTER_DATA_KEY];

export const getImportFilterData = (state) => _getModuleState(state).importFilterData;
